import React from "react";
import { Navigate } from "react-router-dom";
import { CandlestickChart } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import TermsGate from "./TermsGate";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center" style={{ background: "var(--bg)" }} data-testid="auth-loading">
        <div className="grid place-items-center rounded-2xl animate-pulse" style={{ width: 52, height: 52, background: "linear-gradient(135deg,#8b5cf6,#6d28d9)" }}>
          <CandlestickChart size={26} color="#fff" strokeWidth={2.4} />
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (!user.termsAccepted) return <TermsGate />;

  return children;
}
